/*
 * File: /src/router/routes/webhooks.js
 * Created Date: Thursday April 7th 2022
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 7th April 2022 10:10:30 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2022 AdBase, Inc.
 */

const WebhookList = () =>
  import(
    /* webpackChunkName: "Webhook" */ 'src/components/Dashboard/Views/Webhooks/WebhookList.vue'
  );
const WebhookEdit = () =>
  import(
    /* webpackChunkName: "Webhook" */ 'src/components/Dashboard/Views/Webhooks/WebhookEdit.vue'
  );

export const webhookRoutes = [
  {
    path: 'webhooks/list',
    name: 'Webhook List',
    component: WebhookList,
  },
  {
    path: 'webhooks/add/',
    name: 'Webhook Create',
    component: WebhookEdit,
  },
  {
    path: 'webhooks/edit/:id',
    name: 'Webhook Edit',
    component: WebhookEdit,
    props: route => ({ id: parseInt(route.params.id)}),
  },
];
